"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var fp_1 = require("lodash/fp");
var html_attributes_1 = require("../../helpers/html-attributes");
var react_router_dom_1 = require("react-router-dom");
var pickAllowed = (0, fp_1.pickBy)(function (value, key) { return html_attributes_1.htmlAttributes.includes(key); });
var Tab = function (props) {
    var _a = props.as, Component = _a === void 0 ? 'a' : _a, active = props.active, className = props.className, disabled = props.disabled, onClick = props.onClick, value = props.value, children = props.children, name = props.name, to = props.to, rest = __rest(props, ["as", "active", "className", "disabled", "onClick", "value", "children", "name", "to"]);
    var handleClick = function () {
        if (disabled || active || !onClick)
            return;
        onClick(value);
    };
    var restProps = (0, react_1.useMemo)(function () { return pickAllowed(rest); }, [rest]);
    if (Component === (react_router_dom_1.Link || react_router_dom_1.NavLink)) {
        restProps.to = to;
    }
    return (react_1.default.createElement(Component, __assign({ className: (0, classnames_1.default)('tab', className, { active: active, disabled: disabled }), onClick: handleClick }, restProps), name || children));
};
exports.Tab = Tab;
exports.default = exports.Tab;
